import React, { PropTypes } from 'react';
import AddButton from '../AddButton';
import LoggedAppBar from '../LoggedLayout/LoggedAppBar';
import AbstractTable from './AbstractTable';
import {FormattedMessage} from 'react-intl';

class AbstractTableView extends AbstractTable {
  static propTypes = {
    ...AbstractTable.propTypes,
    add: PropTypes.func
  };

  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  headerTitle = 'Inbox list';
  confirmRemoveMessage = (
    <FormattedMessage id="record.remove" defaultMessage="Are you sure want to delete record?"/>
  );

  render() {
    let {add} = this.props;

    return (
      <div>
        <LoggedAppBar title={this.headerTitle} isStatic={true}/>
        {this._renderFilter()}
        {super.render()}
        {!!add && <AddButton onClick={add} />}
      </div>
    );
  }

  _renderFilter() {
    return null;
  }
}

export default AbstractTableView;



// WEBPACK FOOTER //
// ./src/components/common/AbstractTableView.js